import { render, staticRenderFns } from "./WuHu.vue?vue&type=template&id=b12cf268&scoped=true&"
import script from "./WuHu.vue?vue&type=script&lang=js&"
export * from "./WuHu.vue?vue&type=script&lang=js&"
import style0 from "./WuHu.vue?vue&type=style&index=0&id=b12cf268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12cf268",
  null
  
)

export default component.exports